module.exports = __webpack_public_path__ + "media/images/icons/crossed_golf_clubs-caa35e3721df61a1381fd2537404cf4b.png";